import { makeAutoObservable } from "mobx";
import type { GetLimitsResponse } from "@smartsuite/limits-engine-api";

export class LimitsStore {
  limits: GetLimitsResponse = {
    planCategory: "",
    limit: 0,
    usage: 0,
    enforceLimit: false,
  };

  constructor() {
    makeAutoObservable(this);
  }

  setLimits(limits: GetLimitsResponse): void {
    this.limits = limits;
  }

  isOverLimit(): boolean {
    return this.limits.enforceLimit && this.limits.usage >= this.limits.limit;
  }

  canPlanBeUpgraded(): boolean {
    return !["enterprise", "signature"].includes(this.limits.planCategory);
  }
}
